module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/devices@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/devices@2x.png
// module id = 1209
// module chunks = 0